if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (!this.validateRequiredProperties()) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      validateRequiredProperties() {
        var isValid = true;
        var firstInvalidElement = null;

        this.clearPropertyErrors();

        var radioGroups = {};
        document.querySelectorAll('input[type="radio"][data-required-property]').forEach(function(input) {
          var name = input.name;
          if (!radioGroups[name]) radioGroups[name] = [];
          radioGroups[name].push(input);
        });

        Object.entries(radioGroups).forEach(function(entry) {
          var inputs = entry[1];
          var checked = inputs.some(function(input) { return input.checked; });
          if (!checked) {
            isValid = false;
            var group = inputs[0].closest('[data-giftbox-group]');
            if (group) {
              group.classList.add('has-error');
              var trigger = group.querySelector('.giftbox-group__trigger');
              if (trigger && !firstInvalidElement) firstInvalidElement = trigger;
            }
            var configurator = inputs[0].closest('.giftbox-configurator');
            var errorEl = configurator ? configurator.querySelector('[data-error-for="giftbox-options"]') : null;
            if (errorEl) errorEl.style.display = 'block';
          }
        });

        var occasionInput = document.querySelector('#Gift-Occasion[data-required-property]');
        if (occasionInput && !occasionInput.value.trim()) {
          isValid = false;
          var occasionField = occasionInput.closest('.gift-occasion-field');
          if (occasionField) {
            occasionField.classList.add('has-error');
            if (!firstInvalidElement) firstInvalidElement = occasionField.querySelector('.custom-select__trigger');
          }
          var occasionError = document.querySelector('[data-error-for="occasion"]');
          if (occasionError) occasionError.style.display = 'block';
        }

        var boxColourInput = document.querySelector('[data-box-colour-input]');
        if (boxColourInput) {
          if (!boxColourInput.value.trim()) {
            isValid = false;
            var boxColourField = boxColourInput.closest('[data-box-colour-field]');
            if (boxColourField) {
              boxColourField.classList.add('has-error');
              if (!firstInvalidElement) firstInvalidElement = boxColourField.querySelector('.custom-select__trigger');
            }
            var boxColourError = document.querySelector('[data-error-for="box-colour"]');
            if (boxColourError) boxColourError.style.display = 'block';
          }
        }

        document.querySelectorAll('textarea[data-required-property]').forEach(function(textarea) {
          if (!textarea.value.trim()) {
            isValid = false;
            textarea.classList.add('field-error-input');
            var msgError = textarea.parentElement.querySelector('[data-error-for="message"]');
            if (msgError) msgError.style.display = 'block';
            if (!firstInvalidElement) firstInvalidElement = textarea;
          }
        });

        if (!isValid && firstInvalidElement) {
          firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        return isValid;
      }

      clearPropertyErrors() {
        document.querySelectorAll('[data-giftbox-group].has-error').forEach(function(el) { el.classList.remove('has-error'); });
        document.querySelectorAll('.gift-occasion-field.has-error').forEach(function(el) { el.classList.remove('has-error'); });
        document.querySelectorAll('[data-box-colour-field].has-error').forEach(function(el) { el.classList.remove('has-error'); });
        document.querySelectorAll('textarea.field-error-input').forEach(function(el) { el.classList.remove('field-error-input'); });
        document.querySelectorAll('[data-error-for]').forEach(function(el) { el.style.display = 'none'; });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
